/**
 * @class AsyncForEach
 * @description
 * @author Kelvin John Santos
 * @version 1.0
 * @since May 16, 2019
 */

export async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

let timer = {},
  promises = {};

export function preventDuplicatedRequest(name, callback, timeInMs = 1000) {
  const promise = new Promise((resolve, reject) => {
    clearTimeout(timer[name]);

    if (promises[name] == null) {
      promises[name] = [];
    }

    timer[name] = setTimeout(async () => {
      try {
        const response = await callback();
        promises[name].forEach((promise) => {
          promise.resolve(response);
        });
      } catch (error) {
        promises[name].forEach((promise) => {
          promise.reject(error);
        });
      }
    }, timeInMs);

    promises[name].push({ resolve, reject });
  });

  return promise;
}

module.export = {
  asyncForEach,
  preventDuplicatedRequest,
};
